import React, { useEffect, useMemo, useState } from "react";
import styles from "./../checkout.module.css";
import AddEditAddressChk from "./AddEditAddressChk";
import { checkOutAction, profileAction } from "../../../redux/action";
import { getUser, isCardEmtpy } from "../../../constant/utils";
import { useDispatch, useSelector } from "react-redux";

import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";

interface IBooking {
  bookingData: any;
  setBookingData: (val: any) => void;
}
const Address = ({ bookingData, setBookingData }: IBooking) => {
  const USER = getUser();
  const dispatch = useDispatch();
  const [open, setOpen] = useState<boolean>(false);
  const [editData, setEditData] = useState<any>({});
  const [addressData1, setAddressData] = useState();
  // const addressData: any[] = useSelector((state: any) => (state.profile.addressList ? state.profile.addressList : []));
  const addressData: any[] = useSelector((state: any) =>
    state.profile.addressList ? state.profile.addressList : []
  );
  const selectedCityId: any = localStorage.getItem("oq:city");
  const handleOpen = (data: any) => {
    setEditData(data);
    setOpen(true);
  };
  const handleClose = () => {
    setEditData({});
    setOpen(false);
  };
  const cityIdLocalString = localStorage.getItem("oq:city");
  const CityIdLocal = cityIdLocalString ? parseInt(cityIdLocalString, 10) : 0;
  const CartData = JSON.parse(localStorage.getItem("CartData") || "[]");
  const SessionId = uuidv4();

  const handleSubmit = (data: any) => {
    let userdatas = {
      UserData: { Id: USER?.Id },
    };
    if (editData?.id) {
      dispatch(
        profileAction.updateAddressAction(
          { ...data, AddressId: editData?.id, ...userdatas },
          () => {
            onSuccessAddMember();
            setBookingData({
              ...bookingData,
              tab: "address",
              selectedAddress: undefined,
              PaymentMode: "",
            });
          }
        )
      );
    } else {
      dispatch(
        profileAction.addAddressAction({ ...data, ...userdatas }, () =>
          onSuccessAddMember()
        )
      );
    }
  };

  function onSuccessAddMember() {
    setOpen(false);
    setEditData({});

    let userdatas = {
      UserData: { Id: USER?.Id },
    };
    dispatch(profileAction.addressListAction(userdatas));
  }

  function getFullAddress(address: any) {
    let fAdd: any = address?.house_no ? address?.house_no : "";
    fAdd += address?.locality_name ? `, ${address?.locality_name}` : "";
    fAdd += address?.landmark ? `, ${address?.landmark}` : "";
    return fAdd;
  }

  function handleSelectAddress(data: any) {
    if (!isCardEmtpy()) {
      var isInValid = false;
      if (!data?.locality_name) {
        toast.error("Colony/Area/Sector is missing.");
        isInValid = true;
      }
      if (!data?.house_no) {
        toast.error("House Number is missing.");
        isInValid = true;
      }

      if (!data?.state_name) {
        toast.error("State Name is missing.");
        isInValid = true;
      }
      if (!data?.city_name) {
        toast.error("City Name is missing.");
        isInValid = true;
      }
      if (!data?.pincode) {
        toast.error("Pincode is missing.");
        isInValid = true;
      }
      if (isInValid) {
        handleOpen(data);
        return;
      }
      dispatch(
        checkOutAction.bookingValidationAction({
          PreferredDate: bookingData?.ScheduleDate,
          PreferredTime: bookingData?.ScheduleTime,
          CityId: data?.city_id,
        })
      );
      setBookingData({
        ...bookingData,
        tab: "schedual",
        selectedAddress: data,
        PaymentMode: "",
      });
    }
  }

  return (
    <React.Fragment>
      <div
        style={{
          maxHeight: "280px",
          overflowY: "auto",
        }}
      >
        <div className={styles.addressBoxList}>
          {selectedCityId ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "200px" }}
            >
              <a
                href=""
                style={{ width: "150px", padding: "5px 20px" }}
                className="book--hexagon active"
                onClick={(e: any) => {
                  e.preventDefault();
                  handleOpen({});
                }}
              >
                <span className="text-capitalize">
                  <img
                    className="mr-2"
                    src="assets/img/my-profile/white-plus.png"
                    aria-hidden="true"
                  />
                  New Address
                </span>
              </a>
            </div>
          ) : (
            <div className={styles.cardEmptyMessage}>
              Please Select city first
            </div>
          )}
          {addressData
            ?.filter((ncity: any) => ncity?.city_id == selectedCityId)
            ?.map((ele: any, idx: any) => (
              <div
                className={`${styles.addressBox} ${
                  bookingData?.selectedAddress?.id === ele?.id
                    ? styles.activeBox
                    : ""
                }`}
                key={idx}
                onClick={() => handleSelectAddress(ele)}
              >
                <div className={styles.addDetails}>
                  {/* <div
                  className={styles.addName}
                >{getFullName(patientData?.first_name,patientData?.last_name)}</div> */}
                  <div className={styles.addTag}>
                    {/* ele?.address_tag */ "Home"}
                  </div>
                  <div>{getFullAddress(ele)}</div>
                  <div>
                    {ele?.city_name}, {ele?.state_name}
                  </div>
                  <div>{ele?.pincode}</div>
                </div>
                <div className={styles.editAddressIcon}>
                  <img
                    src={`assets/img/my-profile/${
                      bookingData?.selectedAddress?.id === ele?.id
                        ? "yedit"
                        : "bedit"
                    }.png`}
                    onClick={(e: any) => {
                      e.stopPropagation();
                      handleOpen(ele);
                    }}
                  />
                </div>
                {bookingData?.selectedAddress?.id === ele?.id && (
                  <div className={styles.selectedIcon}>
                    <img src="assets/img/my-profile/ptick.png" />
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>
      {open && (
        <AddEditAddressChk
          open={open}
          editData={editData}
          handleClose={handleClose}
          handleSubmit={handleSubmit}
        />
      )}
    </React.Fragment>
  );
};

export default React.memo(Address);
